import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { CinderMessage } from './models'

export const cinderMessagesSelector = createSharedSelector(
  getDataSelector<DataKeys.CinderMessages>(DataKeys.CinderMessages),
  (messages: CinderMessage[]): CinderMessage[] => {
    return messages.map((message) => {
      return {
        ...message,
      }
    })
  },
)

export const cinderMessagesForVolumeSelector = createSharedSelector(
  getDataSelector<DataKeys.CinderMessagesForVolume>(DataKeys.CinderMessagesForVolume, [
    'volumeUuid',
  ]),
  (messages: CinderMessage[]): CinderMessage[] => {
    return messages.map((message) => {
      return {
        ...message,
      }
    })
  },
)

export const latestMessageByVolumeSelector = createSharedSelector(
  cinderMessagesSelector,
  (messages: CinderMessage[]): Record<string, CinderMessage> => {
    const messagesByVolumeId = messages.reduce<Record<string, CinderMessage>>((accum, message) => {
      // Only get volume messages that are error messages
      if (message?.resource_type !== 'VOLUME' || message?.message_level !== 'ERROR') {
        return accum
      }
      // Only want latest a volume's latest message
      if (
        accum[message?.resource_uuid] &&
        accum[message?.resource_uuid].created_at > message.created_at
      ) {
        return accum
      }
      return {
        ...accum,
        [message?.resource_uuid]: message,
      }
    }, {})
    return messagesByVolumeId
  },
)

export const cinderMessageSelector = createSharedSelector(
  getDataSelector<DataKeys.CinderMessage>(DataKeys.CinderMessage),
  (data: CinderMessage[]): CinderMessage | null => {
    // Extract first element from array since API returns [message]
    return data && data.length > 0 ? data[0] : null
  },
)
